import React, {
  FunctionComponent,
  ReactNode,
  HTMLAttributes,
  useRef,
  useImperativeHandle,
} from 'react';
import * as styles from './Text.module.scss';

export type TextProps = {
  size?: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';
  variant?:
    | 'default'
    | 'weak'
    | 'medium'
    | 'strong'
    | 'neutral'
    | 'brand'
    | 'brand-strong'
    | 'primary'
    | 'danger'
    | 'warning'
    | 'success';
  component?: string | FunctionComponent<any>;
  className?: string;
  children?: ReactNode;
} & HTMLAttributes<any>;

const Text = (
  { size, variant, component = 'p', className, children, ...props }: TextProps,
  ref: React.ForwardedRef<any>
) => {
  const componentType = component;

  const classes = [styles.text];
  if (size) classes.push(styles[size]);
  if (variant) classes.push(styles[variant]);
  if (className) classes.push(className);

  const forwardedRef = useRef<any>(null);
  useImperativeHandle(ref, () => forwardedRef.current);

  return React.createElement<any>(
    componentType,
    {
      ref: forwardedRef,
      className: classes.join(' ') || '',
      ...props,
    },
    children
  );
};

const forwardedText = React.forwardRef<any, TextProps>(
  Text
) as React.FC<TextProps>;
export { forwardedText as Text };
